import { useEffect, useState } from 'react';
import { AppQualifier } from './appQualifier';
import debounce from './debounce';

type Device = 'app' | 'desktop' | 'mobile';

const MOBILE_WIDTH = 768;
const DEVICE = { APP: 'app', DESKTOP: 'desktop', MOBILE: 'mobile' } as const;

let device: Device;

export const setDevice = (appQualifier: AppQualifier) => {
  if (appQualifier.origin === DEVICE.APP) {
    device = DEVICE.APP;
  } else if (isMobileDevice()) {
    device = DEVICE.MOBILE;
  } else {
    device = DEVICE.DESKTOP;
  }
};

export const getDevice = () => device;

const getWindowWidth = () => window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

export const isMobileDevice = (providedWindowWidth?: number) =>
  (providedWindowWidth ?? getWindowWidth()) <= MOBILE_WIDTH;

const useIsMobileDevice = () => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    const onResize = debounce(() => {
      setWindowWidth(getWindowWidth());
    }, 1000);

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isMobileDevice(windowWidth);
};

export default useIsMobileDevice;
